import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-reputation-analytics-card',
  templateUrl: './reputation-analytics-card.component.html',
  styleUrls: ['./reputation-analytics-card.component.scss']
})
export class ReputationAnalyticsCardComponent implements OnInit {

  @Input() data:any;

  constructor() { }

  ngOnInit() {
  }

}
